import { ClientPortalWebNarratives } from "cpl-react-common/components/Enums/ClientPortalWebNarratives";
import { useSelector } from "react-redux";
import { getWebNarrative, selectLoading, selectWebNarrative } from "./components/WebNarrativeSlice";
import { useThunkDispatch } from "setup/redux/thunkDispatch";
import { useEffect } from "react";
import { ActivityIndicator } from "cpl-react-common/components/ActivityIndicators/ActivityIndicator";
import { sanitizeHtml } from "cpl-react-common/Helpers/HtmlSanitizerHelpers";

type WebNarrativeProps = {
  webNarrativeID: ClientPortalWebNarratives;
};

export const WebNarrative: React.FC<WebNarrativeProps> = ({ webNarrativeID }: WebNarrativeProps) => {
  const thunkDispatch = useThunkDispatch();
  const loading = useSelector(selectLoading);
  const webNarrative = useSelector(selectWebNarrative);

  useEffect(() => {
    thunkDispatch(getWebNarrative(webNarrativeID));
  }, [thunkDispatch, webNarrativeID]);

  return (
    <ActivityIndicator isBusy={loading}>
      {webNarrative.description != null && webNarrative.description != "" && (
        <h2
          className="cpl-text-primary fs-5 fw-semibold my-1"
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(webNarrative.description) }}
        />
      )}
    </ActivityIndicator>
  );
};
